var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.body_show)?_c('div',{staticClass:"he-review-box"},[_c('ul',{staticClass:"he-review"},[_c('li',[_c('img',{attrs:{"src":_vm.data.headimgurl}}),_c('div',[_vm._v("嗨，我正在做《职业发展健康指数测评》，很想知道在你眼中我的突出优势能力有哪些。请帮我真实的评价一下吧，这对于我更好的了解自己特别重要，非常感谢~")])]),_c('li',[_c('img',{attrs:{"src":_vm.data.headimgurl}}),_c('div',[_vm._v("另，这个评价为匿名评价，会与其他评价一起形成我的能力优势图，评价完成后，你也可以免费获得一次《职业发展健康指数测评》，帮你更好的了解当下的职业状态，还蛮有意思，可以试试看：）")])])]),_c('router-link',{staticClass:"to-review",attrs:{"to":{
        path:'/evaluation_name',
        query:{
            cid:this.$route.query.cid,
            uid:this.$route.query.uid
        }
    }}},[_vm._v("\n        为我评价\n    ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }